document.addEventListener('DOMContentLoaded', function () {
  console.warn("xaxaaaaaaaaaaaaa00");

  var step1Btn = document.getElementById('step1-start-pack');
  var customDiv = step1Btn && step1Btn.nextElementSibling && step1Btn.nextElementSibling.classList.contains('my-custom-new-design') ? step1Btn.nextElementSibling : null;
  if (step1Btn && customDiv) {
    step1Btn.addEventListener('click', function () {
      customDiv.classList.toggle('hidden');
      step1Btn.classList.toggle('active');
    });
  }
  let step1Btnpagestep = document.querySelector('.page-step-1 #step1-start-pack');
  if (step1Btnpagestep) {
      step1Btnpagestep.addEventListener('click', function () {
          let typeSelectA = document.querySelector("#type-select a");
          if(typeSelectA){
              typeSelectA.click();
          }
      });
    }

  // Variable to hold selected pack name
  let selectedPackName = null;

  // Detect pack selection from .discount-buttons
  document.querySelectorAll('.discount-buttons').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedPackName = btn.textContent.trim(); // Save the selected text
      console.warn("Selected pack:", selectedPackName);

      // Optional visual feedback
      document.querySelectorAll('.discount-buttons').forEach(el => el.classList.remove('selected'));
      btn.classList.add('selected');

      // Update the 'Start with a Pack' button text to the selected pack
      const packText = btn.querySelector('.pack-select-content-container p');
      if (packText) {
        document.querySelectorAll('.custom-button-pack-step1').forEach(function (button) {
          // Extract the number from the pack text (e.g., 'PACK OF 3' -> 3)
          const match = packText.textContent.match(/\d+/);
          if (match) {
            button.textContent = `1. Pack of ${match[0]}`;
            button.classList.add('selected-pack');
            button.classList.add('disable');
            button.classList.remove('clicked');
          } else {
            button.textContent = packText.textContent;
            button.classList.add('selected-pack');
            button.classList.add('disable');
            button.classList.remove('clicked');
          }
        });
      }
    });
  });



  // Step 2 logic
  var step1Div = document.querySelector('.my-custom-new-design');
  var step2Btn = document.getElementById('step2-pick-cut');
  var step2Div = document.querySelector('.my-custom-new-design-step2');
  if (step2Btn && step2Div && step1Div) {
    step2Btn.addEventListener('click', function () {
      if (!selectedPackName) {
        alert("Please select a pack before continuing.");
        return;
      }

      // Display selected pack in Step 2 (if there's a placeholder span)
      const target = document.querySelector('.step2-pack-display');
      if (target) {
        target.textContent = selectedPackName;
      }

      step2Div.classList.remove('hidden');
      step1Div.classList.add('hidden');
    });
  }

  // Step 3 logic
  var step3Btn = document.getElementById('step3-find-fit');
  var step3Div = document.querySelector('.my-custom-new-design-step3');
  if (step3Btn && step3Div && step2Div) {
    step3Btn.addEventListener('click', function () {
      step3Div.classList.remove('hidden');
      step2Div.classList.add('hidden');
    });
  }

  // Step 4 logic
  var step4Btn = document.querySelector('#step4-choose-palette button');
  var step4Div = document.querySelector('.my-custom-new-design-step4');
  if (step4Btn && step4Div && step3Div) {
    step4Btn.addEventListener('click', function () {
      step4Div.classList.remove('hidden');
      step3Div.classList.add('hidden');
    });
  }

  const addToPackBtn = document.getElementById('add-to-pack');
  const targetElement = document.querySelector('.color-select-preview.my-custom-new-design-step4');

  if (addToPackBtn && targetElement) {
    addToPackBtn.addEventListener('click', function () {
      targetElement.classList.add('hidden');
    });
  }


  document.querySelectorAll('.review-top.my-custom-new-design-step2 .tab-button').forEach(function (tabButton) {
    tabButton.addEventListener('click', function () {
      const parent = tabButton.closest('.review-top.my-custom-new-design-step2');
      if (parent) {
        setTimeout(() => {
          parent.classList.add('hidden');

          const step3 = document.querySelector('.my-custom-new-design-step3');
          if (step3) {
            step3.classList.remove('hidden');
          }
        }, 200);
      }
    });
  });
  

// Step 3 to Step 4 transition
// document.querySelectorAll('.m-product-option--node input[type="radio"]').forEach(function (optionNode) {
//   optionNode.addEventListener('click', function () {
//     const customstep3 = document.querySelector('.my-custom-new-design-step3');
//     const customstep4 = document.querySelector('.my-custom-new-design-step4');

//     if (customstep3 && customstep4) {
//       customstep3.classList.add('hidden');
//       customstep4.classList.remove('hidden');
//     }
//   });
// });


  // --- Build a Pack dynamic UI updates ---

  // 1. Update pack count in left container when a pack is selected
  function updatePackCount(count) {
    document.querySelectorAll('.pack-of').forEach(el => el.textContent = count);
  }

  document.querySelectorAll('.discount-buttons').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const count = btn.getAttribute('data-quantity');
      if (count) updatePackCount(count);
    });
  });

  // Helper: update step button text
  function updateStepButton(step, value) {
    let btn, defaultText;
    if (step === 'style') {
      btn = document.querySelector('#step2-pick-cut button');
      defaultText = '2. Pick Your Cut';
    } else if (step === 'size') {
      btn = document.querySelector('#step3-find-fit button');
      defaultText = '3. Find Your Fit';
    } else if (step === 'design') {
      btn = document.querySelector('#step4-choose-palette button');
      defaultText = '4. Choose your Palette';
    }
    if (btn) {
      if (value && value !== 'Not Selected') {
        if (step === 'style') {
          btn.textContent = `2. ${value}`;
        } else if (step === 'size') {
          btn.textContent = `3. Size ${value}`;
        } else if (step === 'design') {
          btn.textContent = `4. ${value}`;
        }
        btn.style.color = '#D31E4E';
      } else {
        btn.textContent = defaultText;
        btn.style.color = '';
      }
    }
  }

  // 2. Update selected type on style step
  function updateTypeLabel(type) {
    document.querySelectorAll('.type-label--selected').forEach(el => el.textContent = type);
    updateStepButton('style', type);
  }

  let currentSwatchIndex = 0;

  document.querySelectorAll('.my-custom-new-design-step2 .tab-button').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      document.getElementById('step3-find-fit')?.classList.remove('disabled');
      document.getElementById('step4-choose-palette')?.classList.remove('disabled');
      let currecurrentSwatchIndexdiv = document.querySelector("#pack-prevew-div");
      let currecurrentSwatchIndexvalue = Number(currecurrentSwatchIndexdiv.dataset.currentswatch) || 0;
      currentSwatchIndex = currecurrentSwatchIndexvalue;

      const type = btn.getAttribute('data-name') || btn.textContent.trim();
      updateTypeLabel(type);

      const img = btn.querySelector('img');
      if (img) {
        const imgSrc = img.getAttribute('src');

        const swatchImgs = document.querySelectorAll('#pack-prevew-div .pack-swatch img');
        console.warn('Total image slots generated:', swatchImgs.length);

        // Only fill the next available slot based on index
        if (currentSwatchIndex < swatchImgs.length) {
          const swatchImg = swatchImgs[currentSwatchIndex];
          swatchImg.setAttribute('src', imgSrc);
          swatchImg.setAttribute('data-filled', 'true');

          // ✅ Add the type to the corresponding .pack-swatch
          const swatchDiv = swatchImg.closest('.pack-swatch');
          if (swatchDiv) {
            // Remove any old type span first
            const oldTypeSpan = swatchDiv.querySelector('.type-span');
            if (oldTypeSpan) oldTypeSpan.remove();

            // Insert the new type span before the close button
            const closeSpan = swatchDiv.querySelector('.close');
            if (closeSpan) {
              const typeSpan = document.createElement('span');
              typeSpan.className = 'type-span';
              typeSpan.textContent = type;
              closeSpan.before(typeSpan);
            }
          }
          
          // currentSwatchIndex++;
        }
      }
    });
  });



  // 3. Update selected size on size step
  function updateSizeLabel(size) {
    document.querySelectorAll('.option-label--selected').forEach(el => el.textContent = size);
    updateStepButton('size', size);
  }
  document.querySelectorAll('.m-product-option--node input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.checked) {
        const size = this.value;
        updateSizeLabel(size);

        // Get current swatch slot (just like type uses currentSwatchIndex - 1)
        const swatchImgs = document.querySelectorAll('#pack-prevew-div .pack-swatch img');

        // Avoid negative index
        // const targetIndex = Math.max(currentSwatchIndex - 1, 0);
        const targetIndex = currentSwatchIndex;
        
        const swatchImg = swatchImgs[targetIndex];

        if (swatchImg) {
          const swatchDiv = swatchImg.closest('.pack-swatch');

          if (swatchDiv) {
            // ✅ Remove type span if it exists
            const typeSpan = swatchDiv.querySelector('.type-span');
            if (typeSpan) {
              typeSpan.remove(); // or typeSpan.style.display = 'none';
            }

            // ✅ Remove old size span if already present
            const oldSizeSpan = swatchDiv.querySelector('.size-span');
            if (oldSizeSpan) oldSizeSpan.remove();

            // ✅ Add new size span
            const closeSpan = swatchDiv.querySelector('.close');
            if (closeSpan) {
              const sizeSpan = document.createElement('span');
              sizeSpan.className = 'size-span';
              sizeSpan.textContent = size;
              closeSpan.before(sizeSpan);
            }
          }
        }
      }
    });
  });


  // 4. Update selected design on design step
  function updateDesignLabel(design) {
    document.querySelectorAll('.color-select-preview .type-label--selected').forEach(el => el.textContent = design);
    updateStepButton('design', design);
  }
  // Use event delegation for swatch selection
  var colorSelectPreview = document.querySelector('.color-select-preview');
  if (colorSelectPreview) {
    colorSelectPreview.addEventListener('click', function (e) {
      const btn = e.target.closest('.tab-swatch');
      if (btn) {
        let design = btn.getAttribute('data-name');
        const paletteBtn = document.querySelector('#step4-choose-palette button');
        if (paletteBtn && design) {
          paletteBtn.textContent = `4. ${design}`;
        }
        updateDesignLabel(design);
      }
    });
  }

  // 5. On Add to Pack, add summary to left and reset selections
  const addToPackBtn2 = document.getElementById('add-to-pack');
  if (addToPackBtn2) {
    addToPackBtn2.addEventListener('click', function () {
      // Gather selections
      const packCount = document.querySelector('.pack-of')?.textContent || '';
      const type = document.querySelector('.type-label--selected')?.textContent || '';
      const size = document.querySelector('.option-label--selected')?.textContent || '';
      const design = document.querySelector('.color-select-preview .type-label--selected')?.textContent || '';
      // Add to left container
      const container = document.querySelector('.preview-pack-products');
      if (container) {
        const div = document.createElement('div');
        div.className = 'pack-product-summary';
        div.innerHTML = `<div><b>Pack:</b> ${packCount}</div><div><b>Type:</b> ${type}</div><div><b>Size:</b> ${size}</div><div><b>Design:</b> ${design}</div>`;
        container.appendChild(div);
      }
      // Reset selections and step button texts
      updateTypeLabel('Not Selected');
      updateSizeLabel('Not Selected');
      updateDesignLabel('Not Selected');
      updateStepButton('style', '');
      updateStepButton('size', '');
      updateStepButton('design', '');
    });
  }

  // --- Step content show/hide logic ---
  // Remove the stepMap logic and use explicit handlers for each step

  function hideAllStepContents() {
    document.querySelectorAll('.my-custom-new-design, .my-custom-new-design-step4').forEach(div => div.classList.add('hidden'));
  }

  // Step 1 button
  if (step1Btn && customDiv) {
    step1Btn.addEventListener('click', function () {
      hideAllStepContents();
      customDiv.classList.remove('hidden');
      step1Btn.classList.toggle('active');
    });
  }
  // Step 2 button
  if (step2Btn && step2Div) {
    step2Btn.addEventListener('click', function () {
      if (!selectedPackName) {
        alert("Please select a pack before continuing.");
        return;
      }
      hideAllStepContents();
      step2Div.classList.remove('hidden');
    });
  }
  // Step 3 button
  if (step3Btn && step3Div) {
    step3Btn.addEventListener('click', function () {
      hideAllStepContents();
      step3Div.classList.remove('hidden');
    });
  }
  // Step 4 button
  if (step4Btn && step4Div) {
    step4Btn.addEventListener('click', function () {
      hideAllStepContents();
      step4Div.classList.remove('hidden');
    });
  }

  // Hide step content on selection
  // Step 1: Pack selection
  document.querySelectorAll('.discount-buttons').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const contentDiv = document.querySelector('.my-custom-new-design');
      if (contentDiv) contentDiv.classList.add('hidden');
    });
  });
  // Step 2: Type selection
  document.querySelectorAll('.tab-button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const contentDiv = document.querySelector('.my-custom-new-design-step2');
      contentDiv.classList.add('hidden');
    });
  });
  // Step 3: Size selection
  document.querySelectorAll('.m-product-option--node input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.checked) {
        const contentDiv = document.querySelector('.my-custom-new-design-step3');
        if (contentDiv) contentDiv.classList.add('hidden');
        const belowcontentDivstep4 = document.querySelector('.my-custom-new-design-step4');
        if (belowcontentDivstep4.classList.contains('hidden')) belowcontentDivstep4.classList.remove('hidden');
      }
    });
  });
  // Step 4: Design selection (event delegation)
  if (colorSelectPreview) {
    colorSelectPreview.addEventListener('click', function (e) {
      const btn = e.target.closest('.tab-swatch');
      if (btn) {
        const contentDiv = document.querySelector('.my-custom-new-design-step4');
        if (contentDiv) contentDiv.classList.add('hidden');
      }
    });
  }
});

document.querySelectorAll('.custom-button-pack-step1').forEach(button => {
  button.addEventListener('click', function () {
    // Remove 'clicked' class from all buttons (optional if you want only one selected at a time)
    document.querySelectorAll('.custom-button-pack-step1').forEach(btn => btn.classList.remove('clicked'));

    // Add 'clicked' class to the clicked button
    this.classList.add('clicked');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.custom-button-pack-step');

  // Add .clicked class on button click (without interfering with other handlers)
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      this.classList.add('clicked');
    });
  });

  // Remove .clicked from all when clicking outside
  document.addEventListener('click', function (event) {
    buttons.forEach(btn => {
      // Only remove if the click was NOT inside any button
      if (!btn.contains(event.target)) {
        btn.classList.remove('clicked');
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Listen for clicks on all tab buttons
  document.querySelectorAll('.tab-button').forEach(button => {
    button.addEventListener('click', function () {
      // Remove .active from all tab buttons
      document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));

      // Add .active to the clicked one
      this.classList.add('active');

      // Reset border-color on all .type_button inside .tabs
      document.querySelectorAll('.tabs .type_button').forEach(el => {
        el.style.borderColor = '';
      });

      // // Find the closest .type_button inside .tabs
      // const typeButton = this.closest('.type_button');
      // if (typeButton && typeButton.closest('.tabs')) {
      //   typeButton.style.border = '2px solid #D31E4E';
      // }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Listen for changes on all radio inputs inside .m-product-option--node
  document.querySelectorAll('.m-product-option--node input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function () {
      // Get all siblings in the same group (if needed)
      const allNodes = document.querySelectorAll('.m-product-option--node');

      // Remove 'active' class from all
      allNodes.forEach(node => node.classList.remove('active'));

      // Add 'active' class to the parent of the checked input
      if (this.checked) {
        this.closest('.m-product-option--node').classList.add('active');
      }
    });
  });
});


// document.addEventListener('click', function (e) {
//   if (e.target.closest('.close')) {
//     const swatch = e.target.closest('.pack-swatch');
//     if (!swatch) return;

//     const swatchBtn = swatch.querySelector('.pack-swatch-img');
//     if (swatchBtn) {
//       const removedSize = swatchBtn.getAttribute('data-size');

//       // Uncheck the corresponding size radio input
//       document.querySelectorAll('.m-product-option--node input[type="radio"]').forEach(function (radio) {
//         if (radio.value === removedSize) {
//           radio.checked = false;
//         }
//       });

//       // Clear the size data
//       swatchBtn.setAttribute('data-size', '');
      
//       const img = swatchBtn.querySelector('img');
//       if (img) {
//         img.style.display = 'none';
//         img.setAttribute('data-filled', 'false');
//       }

//       // Hide the size span
//       document.querySelectorAll('.size-span').forEach(function (span) {
//         if (span.textContent.trim() === removedSize) {
//           span.classList.add('hidden');
//         }
//       });
//     }
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const reviewButton = document.querySelector('.m-richtext__button.m-sticky-addtocart.review-button');
  const finishButton = document.querySelector('.bundle-button');
  const notificationWrapper = document.querySelector('.bundle-notification-wrapper');
  const bundleHeading = document.querySelector('.bundle-heading');
  const readybundleHeading = document.querySelector('.pack-ready-bundle-heading');
  const bundleDescription = document.querySelector('.bundle-description');
  const readybundleDescription = document.querySelector('.pack-ready-bundle-description');
  const bundleNote = document.querySelector('.bundle-note');
  const readybundleNote = document.querySelector('.pack-ready-bundle-note');
  const customstep2button = document.querySelector('#step2-pick-cut .m-button.m-button--primary.custom-button-pack-step');
  const customstep3button = document.querySelector('#step3-find-fit .m-button.m-button--primary.custom-button-pack-step');
  const customstep4button = document.querySelector('#step4-choose-palette .m-button.m-button--primary.custom-button-pack-step');
  const step2content = document.querySelector('.my-custom-new-design-step2');

  if (!reviewButton || !finishButton) return;

  function toggleBundleUI() {
    const isHidden = reviewButton.classList.contains('hidden');

    if (isHidden) {
      finishButton.setAttribute('disabled', 'disabled');
      finishButton.textContent = 'FINISH PACK';
      finishButton.removeAttribute('style');
      finishButton.classList.add('disabled');

      if (notificationWrapper) notificationWrapper.removeAttribute('style');
      if (bundleHeading) bundleHeading.style.display = 'block';
      if (bundleDescription) bundleDescription.style.display = 'block';
      if (bundleNote) bundleNote.style.display = 'block';
      if (readybundleHeading) readybundleHeading.style.display = 'none';
      if (readybundleDescription) readybundleDescription.style.display = 'none';
      if (readybundleNote) readybundleNote.style.display = 'none';
      if (step2content) step2content.style.display = '';
      if (customstep2button) customstep2button.classList.remove('disable');
      if (customstep3button) customstep3button.classList.remove('disable');
      if (customstep4button) customstep4button.classList.remove('disable');
    } else {
      finishButton.removeAttribute('disabled');
      finishButton.textContent = 'ADD TO CART';
      finishButton.style.cssText = 'background-color:#DCFF9C;color:#D31E4E;border:1.5px solid black;';
      finishButton.classList.remove('disabled');

      if (notificationWrapper) {
        notificationWrapper.style.backgroundColor = '#D31E4E';
        notificationWrapper.style.borderTop = 'none';
      }
      if (bundleHeading) bundleHeading.style.display = 'none';
      if (bundleDescription) bundleDescription.style.display = 'none';
      if (bundleNote) bundleNote.style.display = 'none';
      if (readybundleHeading) readybundleHeading.style.display = 'block';
      if (readybundleDescription) readybundleDescription.style.display = 'block';
      if (readybundleNote) readybundleNote.style.display = 'block';
      if (step2content) step2content.style.display = 'none';
      if (customstep2button) customstep2button.classList.add('disable');
      if (customstep3button) customstep3button.classList.add('disable');
      if (customstep4button) customstep4button.classList.add('disable');
    }
  }

  toggleBundleUI();

  const observer = new MutationObserver(toggleBundleUI);
  observer.observe(reviewButton, {
    attributes: true,
    attributeFilter: ['class']
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const previewSection = document.querySelector(".preview-section");
  const bundleNotification = document.querySelector(".bundle-notification-wrapper");
  const reviewBtn = document.getElementById("review");

  if (!previewSection || !bundleNotification || !reviewBtn) return;

  // When review button is clicked
  // reviewBtn.addEventListener("click", function () {
  //   previewSection.classList.remove("hidden");            // Show preview section
  //   bundleNotification.classList.add("hidden");           // Hide bundle notification
  // });

  // Observer to detect when hidden class is added back to .preview-section
  const observer = new MutationObserver(() => {
    if (previewSection.classList.contains("hidden")) {
      bundleNotification.classList.remove("hidden");       // Show bundle notification
    }
  });

  // Start observing class changes on previewSection
  observer.observe(previewSection, {
    attributes: true,
    attributeFilter: ["class"]
  });
});

document.querySelectorAll('.m-product-option--node').forEach(function (node) {
  node.addEventListener('click', function (event) {
    setTimeout(function () {
      document.querySelectorAll('.my-custom-new-design-step2').forEach(function (el) {
        el.classList.add('hidden'); // or whatever class is being used to hide
      });
    }, 1); // 1ms delay, after other JS runs
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const packButton = document.querySelector('#step1-start-pack button');

  if (packButton && packButton.classList.contains('selected-pack')) {
    packButton.disabled = true;
    packButton.classList.add('disabled'); // Optional for styling
  }
});

document.getElementById('add-to-pack').addEventListener('click', function () {
  const uncheckradioBtn = document.querySelectorAll('.m-product-option--node input[type="radio"]');
  if(uncheckradioBtn){
    uncheckradioBtn.forEach(function (radio) {
      radio.checked = false;
    });
  }
  const step2 = document.querySelector('.review-top.my-custom-new-design-step2');
  if (step2) {
    step2.classList.remove('hidden');
  }
  setTimeout(function () {
    const removeclickbtn = document.querySelector('#step2-pick-cut .custom-button-pack-step');
    const swatches = document.querySelectorAll('.pack-swatch');
    const lastSwatch = swatches[swatches.length - 1];
    const button = lastSwatch.querySelector('button');

    if(removeclickbtn.classList.contains('clicked') && button.classList.contains('active')){
      removeclickbtn.classList.remove('clicked');
    }
  },500);
});



document.addEventListener('DOMContentLoaded', function () {
  const packSelectorButtons = document.querySelectorAll('.m-button.pack-selector-button.m-button--primary');
  const restartTriggers = [...packSelectorButtons, document.getElementById('add-to-pack')];

  const stepConfigs = [
    {
      containerId: 'step2-pick-cut',
      contentClass: 'my-custom-new-design-step2',
    },
    {
      containerId: 'step3-find-fit',
      contentClass: 'my-custom-new-design-step3',
    },
    {
      containerId: 'step4-choose-palette',
      contentClass: 'my-custom-new-design-step4',
    },
  ];

  function runObserverForStep(containerId, contentClass) {
    const container = document.getElementById(containerId);
    if (!container) return false;

    const contentDiv = container.querySelector(`.${contentClass}`);
    const button = container.querySelector('.custom-button-pack-step');

    if (!contentDiv || !button) return false;

    console.log(`[${containerId}] Observer init`);

    // Initial state
    if (!contentDiv.classList.contains('hidden')) {
      button.classList.add('clicked');
    } else {
      button.classList.remove('clicked');
    }

    const observer = new MutationObserver(() => {
      if (!contentDiv.classList.contains('hidden')) {
        button.classList.add('clicked');
      } else {
        button.classList.remove('clicked');
      }
    });

    observer.observe(contentDiv, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return true;
  }

  function runAllObservers() {
    stepConfigs.forEach(({ containerId, contentClass }) => {
      const interval = setInterval(() => {
        const success = runObserverForStep(containerId, contentClass);
        if (success) {
          clearInterval(interval);
        }
      }, 300);
    });
  }

  // Initial setup
  runAllObservers();

  // Restart process when any trigger is clicked
  restartTriggers.forEach((trigger) => {
    if (trigger) {
      trigger.addEventListener('click', () => {
        console.log('Trigger clicked → re-running observer setup');
        runAllObservers();
      });
    }
  });
});

// document.querySelectorAll('.m-product-option--node').forEach(node => {
//     const label = node.querySelector('.m-product-option--node__label');

//     // Watch for class changes
//     const observer = new MutationObserver(() => {
//         if (node.classList.contains('active')) {
//             label?.classList.add('active');
//         } else {
//             label?.classList.remove('active');
//         }
//     });

//     observer.observe(node, { attributes: true, attributeFilter: ['class'] });
// });


// document.addEventListener('DOMContentLoaded', function () {
//   const custombundlebutton = document.querySelector('.bundle-button-block a');
//   const customstep2button = document.querySelector('#step2-pick-cut custom-button-pack-step');

  
// });

document.addEventListener("DOMContentLoaded", function () {
  const typeButtons = document.querySelectorAll(".my-custom-new-design-step4 .type_button");

  function updateBorders() {
    typeButtons.forEach(typeBtn => {
      const activeTab = typeBtn.querySelector(".my-custom-new-design-step4 .tab-button.active");
      typeBtn.style.border = activeTab ? "none" : "";
    });
  }

  document.addEventListener("click", updateBorders);
  updateBorders(); // run on load
});

document.querySelectorAll('.my-custom-new-design-step3 label').addEventListener('click', function() {
    let tabButton = document.querySelectorAll('.my-custom-new-design-step4 .tabs .type_button .tab-button');
    if (tabButton) {
        tabButton.classList.add('active');
    }
});

document.addEventListener("DOMContentLoaded", function() {
  const packDiv = document.getElementById("pack-prevew-div");
  const toggleBtn = document.getElementById("togglePackBtn");

  toggleBtn.addEventListener("click", function() {
    packDiv.classList.toggle("show-all");
    console.log("Clicked, classes now:", packDiv.className); // Debug

    toggleBtn.textContent = packDiv.classList.contains("show-all") ? "▲" : "▼";
  });
});

document.querySelectorAll(".tab-swatch").forEach((btn) => {
  btn.addEventListener("click", function () {
    const prevImg = this.getAttribute("data-previmg");
    console.log(prevImg);
  });
});

